import React from 'react'
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"
import { BACKEND_APIS } from "@constants"
import useAdminUsersInfo from "Pages/Admin/Users/@hooks/useInfo"
import { masterUsersOptionsMap, userPayload } from "Pages/Admin/Users/@signals"


export default function UserMasterSelector() {
	const { masterUsers, setMasterUsersInfo } = useAdminUsersInfo(userPayload.peek()?.masterUsers, "masterUsers")


	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false}
		multiple
		onChange={e => setMasterUsersInfo(e.target.value)}
		onFinishAjax={options => {
			masterUsersOptionsMap.value = { ...masterUsersOptionsMap.value, ...Object.fromEntries(options.map(o => [String(o.value), o.label])) }
		}}
		placeholder="Master users"
		label="Select one or more masters"
		value={masterUsers}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/admin/options/master-users`}
	/>
}